import  { useState } from "react";
import styles from "./RegistrationForm.module.scss";
import cn from "classnames";
import { ContinueButton } from "../../../../components/ContinueButton/ContinueButton";
import { useNavigate } from "react-router";
import { useRegistrationSection } from "../../../../providers/RegistrationSectionProvider/useRegistrationData";
import { isEmailValid } from "../../../../services/isEmailValid";
import { InputConfirmIcon } from "../../../../components/InputConfirmIcon/InputConfirmIcon";
import { useUserData } from "../../../../providers/UserDataProvider/useUserData";
import { appRegistration } from "../../../../services/appRegistration";
import { pushUpsaleForApp } from "../../../../services/pushUpsaleForApp";
import { Spinner } from "../../../../components/Spinner/Spinner";
import { ampAppRegistration } from "../../../../utils/AmplitudeEvents";

export const RegistrationForm = () => {
  const { userData, setUserData } = useUserData();
  const {content,nextSlug,sessionInfo, planInfo } = useRegistrationSection();
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading,setLoading] = useState(false);
  // name
  const [name, setName] = useState("");
  const [nameFocused, setNameFocused] = useState(false);
  const [nameTouched, setNameTouched] = useState(false);
  // email
  const [email, setEmail] = useState(userData.email || "");
  const [emailFocused, setEmailFocused] = useState(false);
  const [emailTouched, setEmailTouched] = useState(false);
  // email confirm
  const [emailConfirm, setEmailConfirm] = useState("");
  const [emailConfirmFocused, setEmailConfirmFocused] = useState(false);
  const [emailConfirmTouched, setEmailConfirmTouched] = useState(false);
  // password
  const [password, setPassword] = useState("");
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [passwordTouched, setPasswordTouched] = useState(false);
  // password confirm
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [passwordConfirmFocused, setPasswordConfirmFocused] = useState(false);
  const [passwordConfirmTouched, setPasswordConfirmTouched] = useState(false);

  // show/hide password
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  
  // Logic
  const emailMatch = email && email === emailConfirm;
  const passwordValid = password && password.length >= 8;
  const passwordMatch = password && password === passwordConfirm;
  const navigate = useNavigate();
  
  const formValid =
    name &&
    email &&
    isEmailValid(email) &&
    emailConfirm &&
    passwordValid &&
    password &&
    passwordConfirm &&
    emailMatch &&
    passwordMatch;
  const handleSubmit = async () => {
    if (!formValid) return;

    const customerID = sessionInfo?.customer?.id || btoa(email);
    const data = {
      email: email,
      username: name,
      password: password,
      plan: planInfo.title,
      customerID: customerID
    };
    setLoading(true)
    const {data:response,error} = await appRegistration(data);
    const course_ids = userData?.upsaleIDs || null;
    await pushUpsaleForApp(course_ids,email);
    setTimeout(() => {
      setLoading(false)
    }, 300);
    if(response){
      // console.log(response);
      setUserData({
        ...userData,
        appEmail: email,
        userName: name,
        registration:"completed"
      }
      )
      ampAppRegistration(customerID, email);
      setTimeout(() => {
        navigate(nextSlug);
      }, 500);
    }else {
      console.error(error);
      setErrorMessage(error);
    }

  };
  return (
    <>
    {loading && <Spinner state={'opacity'} />}
    <div className={styles.form}>
      {/* Name */}
      <label className={cn(
        styles.field,
        (nameFocused || name) && styles.focus
      )}>
        <div className={cn(
          styles.placeholder,
          (nameTouched && !name) && styles.error
        )}>{content.inputNameText}</div>
        <input
          className={styles.input}
          value={name}
          onFocus={() => setNameFocused(true)}
          onBlur={() => { setNameFocused(false); setNameTouched(true); }}
          onChange={e => setName(e.target.value)}
          autoComplete="name"
        />
        {nameTouched && (name ? InputConfirmIcon(true,styles) : InputConfirmIcon(false,styles))}
      </label>

      {/* Email */}
      <label className={cn(
        styles.field,
        (emailFocused || email) && styles.focus
      )}>
        <div className={cn(
          styles.placeholder,
          (emailTouched && email && !isEmailValid(email)) && styles.error
        )}>{content.inputEmailText}</div>
        <input
          className={cn(
            styles.input,
            (emailTouched && email && !isEmailValid(email)) && styles.inputError
          )}
          type="email"
          value={email}
          onFocus={() => setEmailFocused(true)}
          onBlur={() => { setEmailFocused(false); setEmailTouched(true); }}
          onChange={e => setEmail(e.target.value)}
          autoComplete="email"
        />
        {emailTouched && (
          email
            ? (isEmailValid(email) ? InputConfirmIcon(true) : InputConfirmIcon(false))
            : InputConfirmIcon(false)
        )}
      </label>

      {/* Confirm Email */}
      <label className={cn(
        styles.field,
        (emailConfirmFocused || emailConfirm) && styles.focus
      )}>
        <div className={cn(
          styles.placeholder,
          (emailConfirmTouched && !emailConfirm) && styles.error
        )}>{content.inputConfirmEmailText}</div>
        <input
          className={cn(styles.input, {
            [styles.error]: emailConfirmTouched && !emailMatch && emailConfirm,
          })}
          type="email"
          value={emailConfirm}
          onFocus={() => setEmailConfirmFocused(true)}
          onBlur={() => { setEmailConfirmFocused(false); setEmailConfirmTouched(true); }}
          onChange={e => setEmailConfirm(e.target.value)}
        />
        {emailConfirmTouched && emailConfirm && (
          emailMatch ? InputConfirmIcon(true) : InputConfirmIcon(false)
        )}
      </label>

      {/* Password */}
      <label className={cn(
        styles.field,
        (passwordFocused || password) && styles.focus
      )}>
        <div className={cn(
          styles.placeholder,
          (passwordTouched && !password) && styles.error,
        )}>{content.inputPasswordText}</div>
        <input
          className={cn(
            styles.input,
            passwordTouched && password && password.length < 8 && styles.error
          )}
          type={showPassword ? "text" : "password"}
          value={password}
          onFocus={() => setPasswordFocused(true)}
          onBlur={() => { setPasswordFocused(false); setPasswordTouched(true); }}
          onChange={e => setPassword(e.target.value)}
        />
        <span
          className={styles.toggle}
          onClick={() => setShowPassword(v => !v)}
          style={{ cursor: "pointer" }}
        >
          {showPassword ? showPasswordIcon(true) : showPasswordIcon(false)}
        </span>
      </label>

      {/* Confirm Password */}
      <label className={cn(
        styles.field,
        (passwordConfirmFocused || passwordConfirm) && styles.focus
      )}>
        <div className={cn(
          styles.placeholder,
          (passwordConfirmTouched && !passwordConfirm) && styles.error
        )}>{content.inputConfirmPasswordText}</div>
        <input
          className={cn(styles.input, {
            [styles.error]: passwordConfirmTouched && !passwordMatch && passwordConfirm,
          })}
          type={showPasswordConfirm ? "text" : "password"}
          value={passwordConfirm}
          onFocus={() => setPasswordConfirmFocused(true)}
          onBlur={() => { setPasswordConfirmFocused(false); setPasswordConfirmTouched(true); }}
          onChange={e => setPasswordConfirm(e.target.value)}
        />
        <span
          className={styles.toggle}
          onClick={() => setShowPasswordConfirm(v => !v)}
          style={{ cursor: "pointer" }}
        >
          {showPasswordConfirm ? showPasswordIcon(true) : showPasswordIcon(false)}
        </span>
      </label>

      <div className={styles.terms} dangerouslySetInnerHTML={{ __html: content.footerText }} />
      {errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
      <ContinueButton
        status={formValid ? "active" : "disabled"}
        disabled={!formValid}
        onClick={()=>{
          formValid && handleSubmit();
        }}
      >
        {content.button || "Continue"}
      </ContinueButton>
    </div>
    </>

  );
};



const showPasswordIcon =(status)=>{
if(!status){
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.375 10C0.375 10 3.875 17 10 17C16.125 17 19.625 10 19.625 10C19.625 10 16.125 3 10 3C3.875 3 0.375 10 0.375 10Z" fill="#202020"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M0.507077 10.0141C0.502364 10.0048 0.5 10 0.5 10C0.5 10 3.95455 3 10 3C16.0455 3 19.5 10 19.5 10C19.5 10 19.4976 10.0048 19.4929 10.0141C17.733 12.2261 14.4812 15.2998 10 15.2998C5.51876 15.2998 2.26699 12.2261 0.507077 10.0141Z" fill="#EDEDF2"/>
    </svg>
  )
}else {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.375 10C0.375 10 3.875 3 10 3C16.125 3 19.625 10 19.625 10C19.625 10 16.125 17 10 17C3.875 17 0.375 10 0.375 10Z" fill="#CACADD"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M0.507077 9.98588C0.502364 9.99521 0.5 10 0.5 10C0.5 10 3.95455 17 10 17C16.0455 17 19.5 10 19.5 10C19.5 10 19.4976 9.99521 19.4929 9.98588C17.733 7.7739 14.4812 4.7002 10 4.7002C5.51876 4.7002 2.26699 7.7739 0.507077 9.98588Z" fill="#EDEDF2"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M10.8994 6.61663C11.1008 6.67004 11.2293 6.86001 11.2293 7.0684V8.74058C11.2293 9.01672 11.4531 9.24058 11.7293 9.24058H13.0159C13.2504 9.24058 13.4573 9.40341 13.4814 9.6367C13.4937 9.75612 13.5 9.87732 13.5 10C13.5 11.933 11.933 13.5 10 13.5C8.067 13.5 6.5 11.933 6.5 10C6.5 8.067 8.067 6.5 10 6.5C10.3109 6.5 10.6124 6.54054 10.8994 6.61663Z" fill="#202020"/>
    </svg>
  )
}
}